module.exports = __webpack_public_path__ + "img/d_v6.55895ed.png";